import { render } from "./BackgroundBlogCard.vue?vue&type=template&id=dae14bec"
import script from "./BackgroundBlogCard.vue?vue&type=script&lang=js"
export * from "./BackgroundBlogCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__